import PropTypes from "prop-types";
import Icon from "@react-native-vector-icons/material-design-icons";
import theme from "assets/theme";
import React, { useContext, useMemo, useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import PressableContainer from "webComponentsFormElements/PressableContainer.component";
import { AuthContext } from "webContext/Auth.context";
import { OrganizationContext } from "webContext/Organization.context";

const classes = StyleSheet.create({
  cardBody: {
    fontSize: 12,
    color: theme.color.darkGrey,
    marginTop: 2,
    textAlign: "center",
  },
  cardDetail: {
    fontSize: 11,
    color: theme.color.darkGrey,
    marginTop: 1,
    textAlign: "center",
  },
  deleteIcon: {
    color: theme.color.red,
    fontSize: 20,
  },
  deletePressable: {
    position: "absolute",
    width: 20,
    height: 18,
    right: 12,
    top: 2,
    zIndex: 1,
  },
});

export default function LocationCard(props) {
  const { location, onPress, onDelete } = props;
  const { organizationColor } = useContext(OrganizationContext);
  const { isMessagingManager } = useContext(AuthContext);
  const [hovered, setHovered] = useState(false);
  const stateClasses = useMemo(
    () =>
      StyleSheet.create({
        cardContainer: {
          flexDirection: "column",
          overflow: "hidden",
          borderWidth: 2,
          padding: 25,
          borderColor: organizationColor,
          boxShadow: "1px 2px 3px rgba(0, 0, 0, 0.25)",
          borderRadius: 15,
          justifyContent: "space-evenly",
        },
        cardTitle: {
          fontSize: 18,
          fontWeight: theme.font.weight.semibold,
          color: organizationColor,
          textDecorationColor: organizationColor,
          textDecorationStyle: "solid",
          textDecorationThickness: 1,
          textAlign: "center",
          bottom: 5,
        },
      }),
    [organizationColor],
  );

  return (
    <View
      testID={`location-card-${location.locationId}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <PressableContainer style={stateClasses.cardContainer} onPress={onPress}>
        <Text style={stateClasses.cardTitle}>{location.name}</Text>
        {(location.address || location.city || location.state) && (
          <Text style={classes.cardBody}>
            {[location.address, location.city, location.state]
              .filter(Boolean)
              .join(", ")}
          </Text>
        )}
        {location.primaryPhone && (
          <Text style={classes.cardDetail}>{location.primaryPhone}</Text>
        )}
        {location.primaryEmail && (
          <Text style={classes.cardDetail}>{location.primaryEmail}</Text>
        )}
      </PressableContainer>
      {hovered && !isMessagingManager && (
        <PressableContainer
          testID={`delete-location-${location.locationId}`}
          rootStyle={classes.deletePressable}
          onPress={onDelete}
        >
          <Icon style={classes.deleteIcon} name="close" />
        </PressableContainer>
      )}
    </View>
  );
}

LocationCard.propTypes = {
  location: PropTypes.object.isRequired,
  onPress: PropTypes.func,
  onDelete: PropTypes.func,
};
